export default {
    transform() {
        return (data) =>
            JSON.parse(data).map((option) => ({
                value: option.name,
                label: `${option.name} (${option.code})`,
                data: option,
            }))
    },
}
